import { chartYAxisFormatter, scientificNotationFormatter } from '../../utils/formatters';

export const DEFAULT_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      ticks: {
        autoSkip: true,
        count: 12,
        maxTicksLimit: 12,
        includeBounds: true,
      },
    },
    y: {
      beginsAtZero: true,
      suggestedMin: 0,
      ticks: {
        count: 5,
        maxTicksLimit: 5,
        includeBounds: true,
        callback: value => chartYAxisFormatter.format(value),
      }
    }
  },
};

export const ASSAY_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  plugins: {
    legend: {
      display: true,
      labels: {
        usePointStyle: true,
      }
    },
    tooltip: {
      intersect: false
    }
  },
  scales: {
    x: {
      ticks: {
        autoSkip: true,
        count: 12,
        maxTicksLimit: 12,
        includeBounds: true,
      },
    },
    y: {
      beginsAtZero: true,
      suggestedMin: 0,
      ticks: {
        count: 5,
        maxTicksLimit: 5,
        includeBounds: true,
        callback: value => scientificNotationFormatter.format(value),
      }
    }
  },
}

export const POINT_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
      events: ['mousemove', 'mouseout']
    }
  },
  scales: {
    x: {
      ticks: {
        display: true,
        autoSkip: true,
        count: 12,
        maxTicksLimit: 12,
        includeBounds: true,
      },
      // type: 'time'
    },
    y: {
      beginsAtZero: true,
      suggestedMin: 0,
      ticks: {
        includeBounds: true,
        count: 8,
        maxTicksLimit: 8,
        callback: value => scientificNotationFormatter.format(value),
      }
    }
  },
};

export const BAR_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  plugins: {
    legend: {
      display: true,
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: false,
      beginsAtZero: true,
    }
  },
}

export const HISTOGRAM_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      display: true,
      barPercentage: 1.3,
      ticks: {
        autoSkip: false,
        // max: 4,
      },
      title: {
        display: true,
        text: 'output_0_0',
      }
    },
    y: {
      ticks: {
        beginAtZero: true,
        callback: val => Math.round(val)
      },
      title: {
        display: true,
        text: 'Count',
      }
    }
  }
}

export default {
  LINE: DEFAULT_CHART_OPTIONS,
  BAR: BAR_CHART_OPTIONS,
  POINT: POINT_CHART_OPTIONS,
  HISTOGRAM: HISTOGRAM_CHART_OPTIONS,
}
